/**
 * BookingLogService
 * Service for managing booking logs with media uploads and view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking log CRUD operations with media upload and view endpoints
 */
export class BookingLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingLogService.DEFAULT_SERVICE_PATH,
            basePath: BookingLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY BOOKING ====================
    /**
     * Get all logs for a specific booking
     * @param bookingId - The booking ID
     * @returns Array of booking logs
     */
    async getByBooking(bookingId) {
        const response = await this.getByBookingRaw(bookingId);
        return response.data ?? [];
    }
    /**
     * Get all logs for a specific booking with full response
     * @param bookingId - The booking ID
     * @returns ResponseData with array of booking logs
     */
    getByBookingRaw(bookingId) {
        const url = this.buildUrl(`by-booking/${bookingId}`);
        return this.http.get(url);
    }
    // ==================== MEDIA UPLOAD ====================
    /**
     * Upload media attachment to a booking log
     * @param logId - The booking log ID
     * @param formData - FormData containing the media file
     * @returns The created booking log media record
     */
    async uploadMedia(logId, formData) {
        const response = await this.uploadMediaRaw(logId, formData);
        if (!response.data) {
            throw new Error(`Failed to upload media for booking log ${logId}`);
        }
        return response.data;
    }
    /**
     * Upload media attachment to a booking log with full response
     * @param logId - The booking log ID
     * @param formData - FormData containing the media file
     * @returns ResponseData with the created booking log media record
     */
    uploadMediaRaw(logId, formData) {
        const url = this.buildUrl(`${logId}/media`);
        return this.http.postFormData(url, formData);
    }
    // ==================== VIEW ENDPOINTS ====================
    /**
     * Get booking log view by ID (enriched with related data)
     * @param id - The booking log ID
     * @returns Booking log model view
     */
    async getLogView(id) {
        const response = await this.getLogViewRaw(id);
        if (!response.data) {
            throw new Error(`Booking log view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get booking log view by ID with full response
     * @param id - The booking log ID
     * @returns ResponseData with booking log model view
     */
    getLogViewRaw(id) {
        const url = this.buildUrl(`view/${id}`);
        return this.http.get(url);
    }
}
BookingLogService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingLogService.BASE_PATH = 'api/booking-logs';
//# sourceMappingURL=BookingLogService.js.map